// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchBar_wrapper__KGK67","search":"SearchBar_search__WR+HR","searchButton":"SearchBar_searchButton__hgPYE"};